import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useKeycloak } from '@react-keycloak/web';
import { Button, Grid } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import NodeIndicators from './node-indicators';
import BarIndicators from './bar-indicators';
import NodeDetails from './node-details';
import PercentAvailability from './percent-availability';
import MetricChartItem from '../metric-chart-item';
import Interfaces from './interfaces';
import {
  getDashboardMetrics,
  getNodeDetails,
  getNodeDetailsPercentAvailability,
  setDashboardFiltersSelected,
} from '../../../store/fuse/dashboard';
import { getNotifications } from '../../../theme-layouts/shared-components/notificationPanel/store/dataSlice';
// import DashboardFilter from '../filter';
import LoadingOverlay from '../../loading-overlay';

function DashboardNode() {
  const { nodeId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { keycloak } = useKeycloak();
  const roleKeycloak = keycloak?.realmAccess?.roles[0];
  const id = keycloak?.tokenParsed?.sub;
  const roleId = keycloak?.tokenParsed?.resource_access?.puv.roles[0];

  const [inmueble, setInmueble] = useState('');
  const [region, setRegion] = useState('');
  const [grupo, setGrupo] = useState('');

  const [dateInit, setDateInit] = useState();
  const [dateEnd, setDateEnd] = useState();

  const [loading, setLoading] = useState(false);

  const nodeDetails = useSelector((state) => state?.fuse?.dashboard?.nodeDetails?.generalInfo);
  const interfacesData = useSelector((state) => state?.fuse?.dashboard?.nodeDetails?.interfaces);
  const { nodeSelected } = useSelector((state) => state?.fuse?.dashboard?.nodeDetails?.metricsGraphic);
  // const filtersSelected = useSelector((state) => state?.fuse?.dashboard?.nodeDetails?.filtersSelected);
  const filtersSelected = useSelector((state) => state?.fuse?.dashboard?.dashboard?.filters?.filtersSelected);

  const redirectPath = useSelector((state) => state?.fuse?.dashboard?.dashboard?.redirectPath);
  const { loadingInterfaces, loadingPercentAvailability } = useSelector((state) => state?.fuse?.dashboard?.nodeDetails);

  const [nodeInfo, setNodeInfo] = useState([]);

  useEffect(() => {
    setNodeInfo([{ id: nodeId, nodo: nodeSelected }]);
  }, [nodeId, nodeSelected]);

  useEffect(() => {
    dispatch(getDashboardMetrics());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchAllData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nodeId, filtersSelected]);

  useEffect(() => {
    if (!loadingInterfaces) {
      setLoading(false);
    } else {
      setLoading(true);
    }
  }, [loadingInterfaces]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setRegion('');
      setInmueble('');
      setGrupo('');
      setDateInit();
      setDateEnd();
      dispatch(
        setDashboardFiltersSelected({
          tiempo: { fechaFin: 'update', fechaIni: 'update' },
        })
      );
    }, 300000);
    return () => {
      clearInterval(intervalId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchAllData = () => {
    dispatch(getNotifications({ idUser: id, roleId }));
    dispatch(getNodeDetails(nodeId, filtersSelected));
    dispatch(getNodeDetailsPercentAvailability(nodeId, 'day'));
  };

  const StatusIcon = () => {
    if (nodeDetails?.estadoequipo === '2') {
      return <CheckCircleOutlineIcon fontSize="small" color="success" />;
    }
    if (nodeDetails?.estadoequipo === '0') {
      return <ErrorIcon fontSize="small" color="error" />;
    }
    if (nodeDetails?.estadoequipo === '1') {
      return <WarningAmberIcon fontSize="small" color="warning" />;
    }
    return <InfoIcon fontSize="small" />;
  };

  const handleBackButton = () => {
    navigate(redirectPath);
  };

  return (
    <>
      {['NOC', 'Administrador'].includes(roleKeycloak) && (
        <>
          <div style={{ flexGrow: 1 }}>

            <Grid container spacing={2} sx={{ marginBottom: '20px' }}>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Button startIcon={<ArrowBackIosIcon />} onClick={handleBackButton}>
                  Atrás
                </Button>
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <strong style={{ fontSize: '15px' }}>Detalles Nodo General - </strong>
                {StatusIcon()}
                <strong style={{ fontSize: '15px', marginLeft: '0.5rem' }}>{nodeDetails?.dsnodo} - </strong>
                <strong style={{ fontSize: '15px', marginLeft: '0.5rem' }}>Resumen</strong>
              </Grid>
            </Grid>

            <Grid container spacing={2}>
              <Grid item lg={5} md={5} sm={12} xs={12} className="grid-node-indicators" style={{ alignItems: 'center' }}>
                <NodeIndicators value={nodeDetails?.memoria} label="Uso de Memoria %" metric="memoria" icon />
                <NodeIndicators value={nodeDetails?.disponibilidad} label="Disponibilidad %" metric="disponibilidad" icon />
                <NodeIndicators value={nodeDetails?.cpu} label="Uso de CPU %" metric="cpu" icon />
                <NodeIndicators value={nodeDetails?.latencia} label="Latencia ms" metric="latencia" icon />
              </Grid>
              <Grid item lg={7} md={7} sm={12} xs={12}>
                <BarIndicators />
              </Grid>
            </Grid>

            <Grid container spacing={2} style={{ marginTop: '20px' }}>
              <Grid item lg={5} md={5} sm={12} xs={12} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <NodeDetails />
              </Grid>
              <Grid item lg={7} md={7} sm={12} xs={12}>
                <PercentAvailability filters={filtersSelected} name={nodeDetails?.dsnodo}/>
              </Grid>
            </Grid>

            <Grid container spacing={2} style={{ marginTop: '20px' }}>
              <Grid item lg={6} md={6} sm={12} xs={12} style={{ alignItems: 'center' }}>
                <MetricChartItem nodes={nodeInfo} filters={filtersSelected} showDates={false} order={0} />
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <MetricChartItem nodes={nodeInfo} filters={filtersSelected} showDates={false} order={1} />
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12} style={{ alignItems: 'center' }}>
                <MetricChartItem nodes={nodeInfo} filters={filtersSelected} showDates={false} order={2} />
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <MetricChartItem nodes={nodeInfo} filters={filtersSelected} showDates={false} order={3} />
              </Grid>
            </Grid>

            <Grid container spacing={2} style={{ marginTop: '50px', display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
              <Interfaces />
            </Grid>

            {/* <Grid container spacing={2} style={{ marginTop: '20px' }} className="p-10">
              <Grid item lg={12} md={12} sm={12} xs={12} style={{ alignItems: 'center' }}>
                <MetricChartItem type="single" nodeEquipment={interfaceEquipments[0]} dataType="interface" />
              </Grid>
            </Grid> */}
          </div>
          {loading && <LoadingOverlay />}
        </>
      )}
    </>
  );
}
export default DashboardNode;
